// ========================================
// CONFIGURAÇÃO DO SITE - RECANTO ABELHINHA
// ========================================
// Este arquivo centraliza TODOS os textos, imagens e dados do site.
// Para fazer alterações, basta editar este arquivo e salvar.
// Não precisa mexer em outros arquivos!

export const siteConfig = {
  // ==================
  // DADOS DA ESCOLA
  // ==================
  escola: {
    nome: "Recanto de Educação Infantil Abelhinha",
    tagline: "Acompanhando seus passos na doce estrada do saber",
    anoFundacao: "1990",
    anosExperiencia: 35,
    
    // Contatos
    telefone1: "(19) 3242-5657",
    telefone2: "(19) 99344-5279",
    whatsapp: "5519993445279", // Formato: código do país + DDD + número (sem espaços)
    email: "escolainfantilabelhinha@gmail.com",
    
    // Endereço
    endereco: "Rua Borborema, 189 - Vila Fortuna, Campinas/SP",
    linkMaps: "https://maps.google.com/?q=Rua+Borborema+189+Vila+Fortuna+Campinas+SP",
    
    // Horários
    horarioFuncionamento: "Segunda a Sexta: 7h às 18h30",
    politicaVisitas: "Visitas somente com agendamento",
    
    // Redes Sociais
    instagram: "https://www.instagram.com/escola.abelhinha/",
  },

  // ==================
  // SEÇÃO HERO (TOPO)
  // ==================
  hero: {
    titulo: "Educação com Amor e Dedicação",
    subtitulo: "35 anos de tradição em educação infantil de qualidade",
    descricao: "Berçário, maternal e educação infantil focados no desenvolvimento integral através do afeto, lúdico e aprendizagem significativa.",
    imagemFundo: "https://images.unsplash.com/photo-1502086223501-7ea6ecd79368",
    
    // Estatísticas exibidas
    stats: {
      anos: "35+",
      anosTexto: "Anos de Tradição",
      alunos: "500+",
      alunosTexto: "Alunos Formados",
      satisfacao: "100%",
      satisfacaoTexto: "Satisfação"
    }
  },

  // ==================
  // SOBRE A ESCOLA
  // ==================
  sobre: {
    titulo: "Nossa História",
    descricao: "Fundado em julho de 1990, o Recanto Abelhinha nasceu do sonho de oferecer educação infantil de excelência em Campinas. Com 35 anos de tradição, nossa escola tem como missão promover o desenvolvimento integral das crianças através de uma proposta pedagógica interdisciplinar, que valoriza a criação, socialização e interação.",
    missao: "Promover o desenvolvimento integral da criança em seus aspectos físico, psicológico, intelectual e social.",
    imagem: "https://images.unsplash.com/photo-1627764940620-90393d0e8c34",
    
    valores: [
      "Educação com amor e afeto",
      "Respeito à individualidade",
      "Aprendizagem significativa",
      "Ambiente seguro e acolhedor"
    ]
  },

  // ==================
  // PROGRAMAS
  // ==================
  programas: [
    {
      id: 1,
      nome: "Berçário",
      faixaEtaria: "4 meses a 1 ano",
      descricao: "Ambiente acolhedor e seguro, com profissionais especializados no cuidado e desenvolvimento dos bebês. Estimulação sensorial e motora adequada para cada fase.",
      caracteristicas: [
        "Cuidado especializado",
        "Estimulação sensorial",
        "Ambiente seguro",
        "Rotina personalizada"
      ],
      imagem: "https://images.unsplash.com/photo-1588072432836-e10032774350"
    },
    {
      id: 2,
      nome: "Maternal",
      faixaEtaria: "1 a 3 anos",
      descricao: "Fase de descobertas e exploração. Atividades lúdicas que estimulam o desenvolvimento da linguagem, coordenação motora e socialização.",
      caracteristicas: [
        "Atividades lúdicas",
        "Desenvolvimento motor",
        "Socialização",
        "Expressão criativa"
      ],
      imagem: "https://images.unsplash.com/photo-1560130958-0ea787c275de"
    },
    {
      id: 3,
      nome: "Educação Infantil",
      faixaEtaria: "3 a 5 anos",
      descricao: "Proposta pedagógica que prepara as crianças para os desafios escolares futuros, desenvolvendo autonomia, criatividade e pensamento crítico.",
      caracteristicas: [
        "Alfabetização lúdica",
        "Pensamento crítico",
        "Autonomia",
        "Preparação escolar"
      ],
      imagem: "https://images.unsplash.com/flagged/photo-1551887373-6edba6dacbb1"
    }
  ],

  // ==================
  // ESTRUTURA/INSTALAÇÕES
  // ==================
  instalacoes: [
    {
      id: 1,
      titulo: "Salas Coloridas",
      descricao: "Ambientes temáticos por faixa etária, com mobiliário adequado e materiais pedagógicos"
    },
    {
      id: 2,
      titulo: "Área Externa Segura",
      descricao: "Espaço amplo para brincadeiras e desenvolvimento motor com segurança total"
    },
    {
      id: 3,
      titulo: "Refeitório",
      descricao: "Alimentação balanceada e nutritiva preparada com carinho"
    },
    {
      id: 4,
      titulo: "Biblioteca Infantil",
      descricao: "Cantinho da leitura com livros infantis para estimular a imaginação"
    }
  ],

  // ==================
  // ATIVIDADES
  // ==================
  atividades: [
    {
      id: 1,
      nome: "Música e Movimento",
      descricao: "Desenvolvimento da expressão corporal e sensibilidade musical",
      imagem: "https://images.pexels.com/photos/8422173/pexels-photo-8422173.jpeg"
    },
    {
      id: 2,
      nome: "Artes e Criatividade",
      descricao: "Estímulo à criatividade através de atividades artísticas variadas",
      imagem: "https://images.unsplash.com/photo-1560130958-0ea787c275de"
    },
    {
      id: 3,
      nome: "Atividades ao Ar Livre",
      descricao: "Contato com a natureza e brincadeiras que estimulam o desenvolvimento motor",
      imagem: "https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5"
    }
  ],

  // ==================
  // DEPOIMENTOS
  // ==================
  depoimentos: [
    {
      id: 1,
      nome: "Maria Silva",
      cargo: "Mãe do João - Maternal",
      texto: "Meu filho ama a escolinha! A equipe é maravilhosa e o desenvolvimento dele tem sido incrível. Recomendo de olhos fechados!"
    },
    {
      id: 2,
      nome: "Carlos Santos",
      cargo: "Pai da Ana - Educação Infantil",
      texto: "Ambiente acolhedor e seguro. As professoras são dedicadas e carinhosas. A Ana sempre chega em casa feliz e cheia de novidades!"
    },
    {
      id: 3,
      nome: "Juliana Oliveira",
      cargo: "Mãe do Pedro - Berçário",
      texto: "Confiamos plenamente na equipe. O cuidado com os bebês é excepcional e as instalações são impecáveis. Melhor escolha que fizemos!"
    }
  ],

  // ==================
  // PERGUNTAS FREQUENTES
  // ==================
  faq: [
    {
      id: 1,
      pergunta: "Qual o horário de funcionamento?",
      resposta: "Funcionamos de segunda a sexta-feira, das 7h às 18h30, oferecendo flexibilidade de horários para atender às necessidades das famílias."
    },
    {
      id: 2,
      pergunta: "Como funciona a alimentação?",
      resposta: "Oferecemos alimentação balanceada incluindo café da manhã, almoço e lanches. O cardápio é elaborado por nutricionista e adaptado para cada faixa etária."
    },
    {
      id: 3,
      pergunta: "Posso agendar uma visita?",
      resposta: "Sim! Realizamos visitas somente com agendamento. Entre em contato pelo telefone (19) 3242-5657 ou WhatsApp (19) 99344-5279 para agendar e conhecer nossa estrutura e proposta pedagógica."
    },
    {
      id: 4,
      pergunta: "Qual a metodologia pedagógica?",
      resposta: "Utilizamos uma proposta pedagógica interdisciplinar, com foco no desenvolvimento integral da criança através do lúdico, respeitando a individualidade de cada aluno."
    }
  ],

  // ==================
  // ASSETS (IMAGENS)
  // ==================
  assets: {
    logo: "https://customer-assets.emergentagent.com/job_bb20f472-f37c-4f14-a7f8-13b7abd8c0d5/artifacts/2l1s8394_Logo02.png"
  }
};

// INSTRUÇÕES PARA EDITAR:
// ========================
// 1. Para mudar TEXTOS: Edite os valores entre aspas "" 
//    Exemplo: tagline: "Seu novo texto aqui"
//
// 2. Para mudar IMAGENS: Substitua o link da imagem
//    Exemplo: imagem: "https://seu-novo-link-de-imagem.jpg"
//
// 3. Para mudar TELEFONES/WHATSAPP: 
//    - telefone1, telefone2: Use formato (XX) XXXX-XXXX
//    - whatsapp: Use formato 55XXXXXXXXXXX (sem parênteses, sem espaços)
//
// 4. Para ADICIONAR um novo depoimento, programa ou atividade:
//    Copie o bloco {...} e cole abaixo, mudando o id e os textos
//
// 5. Após editar, SALVE o arquivo. O site será atualizado automaticamente!
